<template>
   <div class="grids">
					<div class="progressbar-heading grids-heading">
						<h2>SIGN IN</h2>
					</div>
					<div class="panel panel-widget forms-panel">
						<div class="forms">
							<div class="form-grids widget-shadow" data-example-id="basic-forms"> 
								<div class="form-title">
									<h4>USER SIGN IN </h4>
								</div>

								<div class="form-body">
									<form v-on:submit.prevent="handleSubmit()"> 
                                    <div class="form-group"> 
                                    <label for="exampleInputEmail1">Email address</label> 
                                    <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email" v-on:change="emailHandler($event)">
                                     </div> <div class="form-group">
                                      <label for="exampleInputPassword1">Password</label> 
                                      <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" v-on:change="passwordHandler($event)">
                                       </div> 
                                    
                                        
                                          <button type="submit" class="btn btn-default">Submit</button>
                                    </form> 
								</div>
							</div>
						</div>
					</div>
					
					
            
            
					
				</div>
</template>

<script>
import axios from "axios";

export default {
  name: 'logout',
  props: {
  
},
data()
{
    return{
   
    }
},
     mounted()
    {
        //check for token and redirect to dashboard
        let accessToken = localStorage.getItem("token");
        if(accessToken != "noToken")
        {
           localStorage.setItem("token","noToken");
               this.$router.push("/timeawards/signIn");
            
        }
     
    }
,
methods:
{
  
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
